(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["product_page-gift-upsell"] && !Shopify.designMode) return;
  try {
    class GiftUpsell extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.toggleCheckbox();
    }

    disconnectedCallback() {
      this.toggleCheckbox();
    }

    toggleCheckbox() {
      const checkbox = $(this).find('input[type="checkbox"]');
      const atcButton = $(this).closest('form').find('button.shpAdd2CartButton');

      $(this).click(function (e) {
        if (e.target.tagName !== "LABEL" &&
            e.target.tagName !== "INPUT") {
            checkbox.prop('checked', !checkbox.prop('checked'));
        };

        $(atcButton).text(
            checkbox.prop('checked') ? $(this).data('atc-text-checked') : $(this).data('atc-text')
        );
      });
    }
  }

  customElements.define('gift-upsell', GiftUpsell);
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["product_page-personalisation"] && !Shopify.designMode) return;
  try {
    class ProductPersonalisation extends HTMLElement {
    constructor() {
      super();

      const inputs = this.querySelectorAll('input.form-control');

      inputs.forEach(input => {
        input.addEventListener('input', this.updateCharacterCounter.bind(this));
      });
    }

    updateCharacterCounter(event) {
      const value = event.target.value;
      const char_limit = event.target.maxLength;
      const char_counter = event.target.parentElement.querySelector('.char_counter');

      char_counter.textContent = char_limit - value.length;
    }
  }

  customElements.define('product-personalisation', ProductPersonalisation);
  } catch(e) { console.error(e); }
})();

})();
